"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isThumbnailResult = exports.isSingleResult = exports.ITemplate = void 0;
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
Object.defineProperty(exports, "ITemplate", { enumerable: true, get: function () { return Types_1.ITemplate; } });
var isSingleResult = function (result) {
    return result.type === "single";
};
exports.isSingleResult = isSingleResult;
var isThumbnailResult = function (result) {
    return result.type === "thumbnail";
};
exports.isThumbnailResult = isThumbnailResult;
